<mat-sidenav-container fullscreen>
  <mat-sidenav-content>
    <div class="container admin-level" [ngClass]="{'new-font':globals.currentUser}">
      <br />
      <div *ngIf="!globals.adminKey && !globals.currentUser">
        <div class="align-center">
          <mat-form-field class="fullwidth">
            <label>{{ 'Adminkod' | translate }}</label>
            <input matInput [(ngModel)]="adminKey">
          </mat-form-field>
          <button mat-raised-button color="primary" (click)="setAdminKey()">{{ 'Ange' | translate }}</button>
        </div>
      </div>
      <div *ngIf="globals.adminKey || (globals.currentUser && globals.currentUser.role == 'ACE')">
        <div class="menu">
          <div class="row">
            <div class="col-auto">
              <button mat-menu-item [routerLink]="[globals.adminPanelUrl('/overview')]">
                <span class="material-symbols-outlined">home</span>
                <span>{{ 'Översikt' | translate }}</span>
              </button>
            </div>
            <div class="col-auto">
              <button mat-menu-item [routerLink]="[globals.adminPanelUrl('/settings')]">
                <span class="material-symbols-outlined">settings</span>
                <span>{{ 'Inställningar' | translate }}</span>
              </button>
            </div>
            <div class="col-auto" *ngIf="globals.userIsAce()">
              <button mat-menu-item [routerLink]="[globals.adminPanelUrl('/users')]">
                <span class="material-symbols-outlined">manage_accounts</span>
                <span>{{ 'Användare' | translate }}</span>
              </button>
            </div>
            <div class="col-auto">
              <button mat-menu-item [routerLink]="[globals.adminPanelUrl('/stores')]">
                <span class="material-symbols-outlined">storefront</span>
                <span>{{ 'Webshoppar' | translate }}</span>
              </button>
            </div>
            <div class="col-auto">
              <button mat-menu-item [routerLink]="[globals.adminPanelUrl('/pictufy')]">
                <span class="material-symbols-outlined">wallpaper</span>
                <span>{{ 'Pictufy' | translate }}</span>
              </button>
            </div>
            <div class="col-auto">
              <button mat-menu-item [routerLink]="[globals.adminPanelUrl('/poster-orders')]">
                <span class="material-symbols-outlined">paid</span>
                <span>{{ 'Ordrar' | translate }}</span>
              </button>
            </div>
            <div class="col-auto" *ngIf="globals.currentUser">
              <button mat-menu-item [routerLink]="[globals.adminPanelUrl('/reclaims')]">
                <span class="material-symbols-outlined">support_agent</span>
                <span>{{ 'Reklamationer' | translate }}</span>
              </button>
            </div>
            <div class="col-auto">
              <button mat-menu-item [routerLink]="[globals.adminPanelUrl('/dashboard')]">
                <span class="material-symbols-outlined">monitoring</span>
                <span>{{ 'Försäljning' | translate }}</span>
              </button>
            </div>
            <div class="col align-right">
              <div *ngIf="adminNotifications && adminNotifications.length">
                <span class="material-symbols-outlined negative-foreground notification-icon clickable"
                  (click)="openNotifications()">warning</span>
              </div>

            </div>
          </div>
        </div>
        <mat-menu></mat-menu>
        <br />
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-sidenav-content>
  <mat-sidenav #notificationsPanel position="end">
    <div class="notifications-panel" [ngClass]="{'new-font':globals.currentUser}">
      <table class="fullwidth styled">
        <ng-container *ngFor="let notification of adminNotifications">
          <tr [ngClass]="{'acknowledged':notification.acknowledge, 'superadmin': !notification.notifyAdmin}"
            class="{{notification.logItem.severity.toLowerCase()}}">
            <td>{{notification.logItem.created | date : 'yyyy-MM-dd HH:mm:ss'}}</td>
            <td>{{notification.storeName}}</td>
            <td class="align-right">
              <button mat-raised-button color="primary" (click)="acknowledge(notification)">
                <span>OK</span>
              </button>
            </td>
          </tr>
          <tr [ngClass]="{'acknowledged':notification.acknowledge, 'superadmin': !notification.notifyAdmin }"
            class="{{notification.logItem.severity.toLowerCase()}}">
            <td colspan="3">{{notification.logItem.message}}</td>
          </tr>
        </ng-container>

      </table>
    </div>
  </mat-sidenav>
